var instanceId = 'post-cn-0mm3vbzyz02';//实例 ID，购买后从控制台获取
var host = 'post-cn-0mm3vbzyz02.mqtt.aliyuncs.com';// 设置当前用户的接入点域名，接入点获取方法请参考接入准备章节文档，先在控制台创建实例
var port = 443;//WebSocket 协议服务端口，如果是走 HTTPS，设置443端口
var topic = 'XXXX';//需要操作的 Topic,第一级父级 topic 需要在控制台申请
var useTLS = true;//是否走加密 HTTPS，如果走 HTTPS，设置为 true
//账号 accesskey，从账号系统控制台获取
//阿里云账号AccessKey拥有所有API的访问权限，建议您使用RAM用户进行API访问或日常运维。
//强烈建议不要把AccessKey ID和AccessKey Secret保存到工程代码里，否则可能导致AccessKey泄露，威胁您账号下所有资源的安全。
//可以把AccessKey ID和AccessKey Secret保存在环境变量。运行本代码示例之前，请先配置环境变量MQTT_AK_ENV和MQTT_SK_ENV
//例如：export MQTT_AK_ENV=access_key_id
//     export MQTT_SK_ENV=access_key_secret
//需要将access_key_id替换为已准备好的AccessKey ID，access_key_secret替换为AccessKey Secret
var accessKey = 'LTAI5tQtTWjyLxLpA6bwEgsg';
//账号的的 SecretKey，在阿里云控制台查看
var secretKey = 'p3trZkHGlFaJLo4miXrirXSiOKlFO2';
var cleansession = true;
var groupId = 'GID_DEVICE_CLOUD_STORES';//MQTT GroupID,创建实例后从 MQTT 控制台创建
var clientId = groupId + '@@@1';//GroupId@@@DeviceId，由控制台创建的 Group ID 和自己指定的 Device ID 组合构成
var mqtt;
var isConn = false;
var reconnectTimeout = 2000;
var username = 'Signature|' + accessKey + '|' + instanceId;//username和 Password 签名模式下的设置方法，参考文档 https://help.aliyun.com/document_detail/48271.html?spm=a2c4g.11186623.6.553.217831c3BSFry7
var password = CryptoJS.HmacSHA1(clientId, secretKey).toString(CryptoJS.enc.Base64);

const callback = {
    pushAudio: function () {

    },
    message: () => {

    },
    comfirmMessage: () => {
        
    },
    success: () => {

    },
}



function MQTTconnect() {
    mqtt = new Paho.MQTT.Client(
        host,//MQTT 域名
        port,//WebSocket 端口，如果使用 HTTPS 加密则配置为443,否则配置80
        clientId//客户端 ClientId
    );
    var options = {
        timeout: 3,
        onSuccess: onConnect,
        mqttVersion: 4,
        cleanSession: cleansession,
        onFailure: function () {
            setTimeout(MQTTconnect, reconnectTimeout);
        },
    };
    mqtt.onConnectionLost = onConnectionLost;
    mqtt.onMessageArrived = onMessageArrived;
    if (username != null) {
        options.userName = username;
        options.password = password;
        options.useSSL = useTLS;//如果使用 HTTPS 加密则配置为 true
    }
    mqtt.connect(options);
}

function disconnect() {
    console.log("主动断开")
    mqtt.disconnect()
}

function onConnect() {
    console.log("连接成功")
    isConn = true;

    callback.success()
}

function onConnectionLost(response) {
    isConn = false;
    console.log("连接丢失")
    // setTimeout(MQTTconnect, reconnectTimeout);
};

function onMessageArrived(message) {
    var topic = message.destinationName;
    var payload = message.payloadString;

    try {
        var json = JSON.parse(payload);
        console.log("mqtt消息",json);
        callback.comfirmMessage(json);
        
        if (json.messageType === 1) {
            const data = JSON.parse(json.data);
            // console.log("mqtt消息",data);
            if (data.type === 'CALL_CUSTOMER_SERVICE') {
                callback.pushAudio(data);
            }
            callback.message(data);
        }
        console.log("mqttmessage", json);
    } catch (e) {
        console.log(e)
    }

}

function setClientId(id) {
    clientId = groupId + '@@@' + id;
    password = CryptoJS.HmacSHA1(clientId, secretKey).toString(CryptoJS.enc.Base64);
    console.log("clientId", clientId);
}


function getConnectStatus() {
    return isConn
}

module.exports = {
    setClientId,
    MQTTconnect,
    getConnectStatus,
    disconnect,
    callback,
}

